const NEAREST_MEDIA_REGION_URL = "https://nearest-media-region.l.chime.aws";
const FALLBACK_REGION = "us-east-1";
const TIMEOUT_MS = 3000;

/**
 * Calls the Chime nearest-media-region endpoint to determine
 * the optimal AWS region for the user's location.
 * Falls back to us-east-1 on any error or timeout.
 */
export async function getNearestMediaRegion(): Promise<string> {
  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);

    const response = await fetch(NEAREST_MEDIA_REGION_URL, {
      signal: controller.signal,
    });
    clearTimeout(timer);

    if (!response.ok) {
      return FALLBACK_REGION;
    }

    const data = await response.json();
    return data?.region || FALLBACK_REGION;
  } catch {
    return FALLBACK_REGION;
  }
}
